import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, Wrench, Info, Phone, MapPin, Building2, Mail } from 'lucide-react';

export function ContactPage() {
  const { t } = useTranslation();

  return (
    <div className="pt-16">
      <div className="bg-gradient-to-br from-blue-900 to-blue-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-6">{t('contact.title')}</h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            {t('contact.subtitle')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        {/* Email Grid */}
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all">
            <AlertTriangle className="w-8 h-8 text-blue-600 mb-4" />
            <h3 className="text-lg font-semibold mb-2">{t('contact.email.abuse.title')}</h3>
            <a href="mailto:abuse@synthohosting.net" className="text-blue-600 hover:text-blue-800">
              {t('contact.email.abuse.address')}
            </a>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all">
            <Wrench className="w-8 h-8 text-blue-600 mb-4" />
            <h3 className="text-lg font-semibold mb-2">{t('contact.email.tech.title')}</h3>
            <a href="mailto:tech@synthohosting.net" className="text-blue-600 hover:text-blue-800">
              {t('contact.email.tech.address')}
            </a>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all">
            <Info className="w-8 h-8 text-blue-600 mb-4" />
            <h3 className="text-lg font-semibold mb-2">{t('contact.email.info.title')}</h3>
            <a href="mailto:info@synthohosting.net" className="text-blue-600 hover:text-blue-800">
              {t('contact.email.info.address')}
            </a>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all">
            <Mail className="w-8 h-8 text-blue-600 mb-4" />
            <h3 className="text-lg font-semibold mb-2">{t('contact.email.admin.title')}</h3>
            <a href="mailto:amministrativo@synthohosting.net" className="text-blue-600 hover:text-blue-800">
              {t('contact.email.admin.address')}
            </a>
          </div>
        </div>

        {/* Contact Info Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <Phone className="w-12 h-12 text-blue-600 mb-6" />
            <h3 className="text-2xl font-bold mb-4">{t('contact.phone.title')}</h3>
            <a href="tel:+390984180706" className="text-blue-600 hover:text-blue-800 text-lg">
              {t('contact.phone.number')}
            </a>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <MapPin className="w-12 h-12 text-blue-600 mb-6" />
            <h3 className="text-2xl font-bold mb-4">{t('contact.address.title')}</h3>
            <address className="not-italic text-gray-700 space-y-2">
              <p>{t('contact.address.line1')}</p>
              <p>{t('contact.address.line2')}</p>
              <p>{t('contact.address.country')}</p>
            </address>
          </div>
        </div>

        {/* Company Information */}
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="flex items-center gap-4 mb-6">
            <Building2 className="w-8 h-8 text-blue-600" />
            <h3 className="text-2xl font-bold">{t('contact.company.name')}</h3>
          </div>
          <div className="space-y-3 text-gray-700">
            <p>{t('contact.company.vat')}</p>
            <p>{t('contact.company.rea')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}